const config = {
  rowSelection: true,
  columns: [
    {
      title: '应收单号',
      dataIndex: 'billNo',
      width: 190,
      render: 'clueIdRender',
    },
    {
      title: '收款类型',
      dataIndex: 'receiptTypeName',
      width: 150
    },
    {
      title: '应收金额',
      dataIndex: 'receivableAmount',
      width: 140,
    },
    // {
    //   title: '实收金额',
    //   dataIndex: 'receiveAmount',
    //   width: 140,
    // },
    {
      title: '已核销金额',
      dataIndex: 'verifiedAmount',
      width: 140,
    },
    {
      title: '未核销金额',
      dataIndex: 'unverifiedAmount',
      width: 140
    },
    {
      title: '核销状态',
      dataIndex: 'verifyStateName',
      width: 100
    },
    {
      title: '应收日期',
      dataIndex: 'receivableDate',
      itemType: 'dateTime',
      width: 160
    },
    {
      title: '支付状态',
      dataIndex: 'payStateName',
      width: 100
    },
    {
      title: '合同类型',
      dataIndex: 'budgetVersionDesc',
      width: 140
    },
    {
      title: '合同号',
      dataIndex: 'contractNo',
      width: 180
    },
    {
      title: '合同金额',
      dataIndex: 'budgetContractAmount',
      width: 100
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 200,
      ellipsis: true,
      // ellipsis: {
      //   showTitle: true,
      // },
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 220,
      render: 'renderOperate',
      fixed: 'right'
    },
  ],
  search: [
    {
      name: 'notEqualVerifyState',
      label: '显示未生效应收单',
      labelProps: {
        width: '150px',
      },
      itemType: 'select',
      key: 'value',
      labelKey: 'lable',
      data: [
        {
          lable: '不显示',
          value: 'verifyStateNotEffective'
        },{
          lable: '显示',
          value: 'noVerifyStateNotEffective'
        }
      ],
    },
    {
      name: 'receiptType',
      label: '收款类型',
      itemType: 'select',
      data: 'receiptTypeList',
      labelKey: 'name',
      key: 'priKey',
    },
    {
      name: 'verifyState',
      label: '核销状态',
      itemType: 'select',
      data: 'verifyStateList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'payState',
      label: '支付状态',
      itemType: 'select',
      data: 'payStateList',
      labelKey: 'description',
      key: 'key',
    },
    {
      name: 'contractType',
      label: '合同类型',
      itemType: 'select',
      data: 'contractTypeList',
      labelKey: 'desc',
      key: 'code',
    },
    {
      name: 'contractNoEndWith',
      label: '合同号',
    },
  ],
  searchInitialValues: {
    'notEqualVerifyState': 'verifyStateNotEffective'
  },
  footer: [
    {
      label: '新增',
      type: 'primary',
      auth: 'ReceivableListAdd',
      events: ['onClick:onAdd'],
    },
    {
      label: '联查收款计划',
      disabled: 'skipRuleDisabled',
      auth: 'ReceivableListRule',
      events: ['onClick:skipRule'],
    },
  ],
  batchActions: [
    {
      label: '合并收款',
      type: 'primary',
      disabled: 'onMergeReceiptsDisabled',
      auth: 'ReceivableListMergeReceipts',
      events: ['onClick:onMergeReceipts'],
    }
  ]
}

export default config
